const MOHJA_DESIGN = {
  COLORS: {
    PRIMARY: '#1A365D',        // Deep Indigo Blue - Professional Depth
    PRIMARY_LIGHT: '#2C5282',  // Rich Indigo - Modern Accent
    PRIMARY_DARK: '#0F2541',   // Extremely Dark Navy Blue - Sophisticated Base
    
    GRADIENT_START: '#1A365D', // Deep Indigo Blue
    GRADIENT_END: '#2C5282',   // Rich Indigo
    
    TEXT_PRIMARY: '#1A202C',   // Very Dark Blue-Gray (Almost Black)
    TEXT_SECONDARY: '#2D3748', // Dark Slate Blue-Gray
    TEXT_LIGHT: '#4A5568',     // Medium Slate Gray
    
    WHITE: '#FFFFFF',
    BACKGROUND: '#F7FAFC',     // Soft, Pale Blue-Gray
    BACKGROUND_LIGHT: '#EDF2F7', // Light Blue-Gray
    
    ACCENT: '#2C5282',         // Consistent with Primary Light
    BORDER: '#A0AEC0',         // Soft Slate Gray Border
    SHADOW: 'rgba(26,32,44,0.1)', // Subtle Shadow with Blue-Gray Undertone
  },
  
  SPACING: {
    xs: 0.25,
    sm: 0.5,
    md: 1,
    lg: 1.5,
    xl: 2,
  },
  
  TYPOGRAPHY: {
    fontFamily: "'Inter', sans-serif",
    fontSize: {
      small: '0.875rem',
      normal: '1rem',
      large: '1.25rem',
    },
  },
  
  ANIMATIONS: {
    duration: {
      fast: '0.2s',
      normal: '0.3s',
      slow: '0.5s',
    },
    timing: {
      ease: 'ease',
      easeIn: 'ease-in',
      easeOut: 'ease-out',
      easeInOut: 'ease-in-out',
    },
  },
};

export default MOHJA_DESIGN;